"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useGraphqlQuery = require("./useGraphqlQuery");
Object.keys(_useGraphqlQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGraphqlQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGraphqlQuery[key];
    }
  });
});
//# sourceMappingURL=index.js.map